<div class="page-layout carded fullwidth ">
    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->
    <!-- CENTER -->
    <div class="center">
        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0"></h2>
        </div>
        <!-- / CONTENT HEADER -->
        <!-- CONTENT CARD -->
        <div class="content-card">
            <div class="card" style="width: 100%;">
                <!--MENU SUPERIOR-->
            </div>
            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <span> </span>
                <button mat-icon-button aria-label="" routerLink="/NOM35/wizard/{{pathTmp}}">
                    <mat-icon style="font-size: 50px; color: #000304;">keyboard_backspace</mat-icon>
                </button>
            </div>

            <div class="content-card mainDiv" style="margin-top: 2%; margin-left: 15%; margin-right: 15%; margin-bottom: 2%;">
                <p>{{nombreSeccionTmp}}</p><br>
                <mat-list>
                    <p mat-subheader>Editar lista de tareas lista de tareas</p>
                    <mat-list-item>
                        <button mat-icon-button aria-label="" (click)="addFieldValueTask(idSeccionTmp,nombreSeccionTmp)">
                            <mat-icon style="font-size: 60px; color: #188FBF;">add_circle_outlin</mat-icon>
                        </button>
                        <p mat-line>Agregar más tareas</p>
                        <p mat-line> Fecha </p>
                    </mat-list-item>
                </mat-list>
            </div><br>
            <div class="content-card mainDiv" style="margin-top: 2%; margin-left: 5%; margin-right: 15%;">
                <table class="taskTables table table-striped table-bordered" style="width: 100%; margin-top: 1%; margin-left: 10%; margin-right: 5%;">
                    <thead>
                        <tr style="width: 100%;">
                            <th style="width: 30%;">Descripción </th>
                            <th style="width: 20%">Responsable</th>
                            <th style="width: 20%">Cargo del Responable</th>
                            <th style="width: 10%;">Fecha</th>
                            <th style="width: 10%;">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!--Add task for the firts time-->
                        <tr *ngFor="let field of fieldArrayTask; let i = index" style="width: 100%; margin-top: 5%;">
                            <td style="width: 30%">
                                <textarea matInput autosize [minRows]="minRows" id="str" [(ngModel)]="NewDescripcion" (blur)="onActTaskDescription($event,idSeccionTmp,IdtaskTmpFirtsSave);" ng-keydown="onActTaskDescription()" placeholder="Nueva Tarea">
                                    </textarea>
                                <mat-icon matSuffix class="secondary-text">description</mat-icon>
                            </td>
                            <td style="width: 20%">
                                <input matInput [(ngModel)]="nombreResponsableTmp" placeholder="Nombre Responsable" (blur)="onActTaskPerson($event,idSeccionTmp,IdtaskTmpFirtsSave);" ng-keydown="onActTaskPerson()" required>
                                <mat-icon matSuffix class="secondary-text">person_outline</mat-icon>
                            </td>
                            <td style="width: 20%">
                                <input matInput [(ngModel)]="cargoResponsableTmp" placeholder="Cargo del responsable" (blur)="onActTaskCargo($event,idSeccionTmp,IdtaskTmpFirtsSave);" ng-keydown="onActTaskCargo()" required>
                                <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                            </td>
                            <td style="width: 10%">
                                <mat-form-field>
                                    <input matInput [matDatepicker]="picker1" placeholder="Angular forms" [formControl]="date" (blur)="onDateTask($event,idSeccionTmp,IdtaskTmpFirtsSave);" ng-keydown="onActTaskCargo()">
                                    <mat-datepicker-toggle matSuffix [for]="picker1" (blur)="onDateTask($event,idSeccionTmp,IdtaskTmpFirtsSave);" ng-keydown="onDateTask()"></mat-datepicker-toggle>
                                    <mat-datepicker #picker1 (blur)="onDateTask($event,idSeccionTmp,IdtaskTmpFirtsSave);" ng-keydown="onDateTask()"></mat-datepicker>
                                </mat-form-field>
                            </td>
                            <td style="width: 10%">
                                <button mat-icon-button aria-label="" (click)="deleteFieldValueTask(i)">
                                        <mat-icon>remove_circle_outline</mat-icon>
                                </button>
                            </td>
                        </tr>
                        <tr *ngFor="let tasklist of TaskListtmp; let i = index" style="width: 100%;">
                            <td style="width:30%; text-align: left;">
                                <textarea matInput autosize [minRows]="minRows" (blur)="onActTaskDescription($event,idSeccionTmp,tasklist._id);" ng-keydown="onActTaskDescription()">
                                    {{tasklist.descripcion}}
                                </textarea>
                                <p>La tarea se encuentra:<a target="_blank" href="./NOM35/wizard/{{tasklist.ruta}}">{{tasklist.nombreLink}}</a> </p>
                            </td>
                            <td style="width:20%; text-align: left;">
                                <textarea matInput autosize [minRows]="minRows" (blur)="onActTaskPerson($event,idSeccionTmp,tasklist._id);" ng-keydown="onActTaskPerson()">
                                    {{tasklist.nombreResponsable}}
                                </textarea>
                            </td>
                            <td style="width:20%; text-align: left;">
                                <textarea matInput autosize [minRows]="minRows" (blur)="onActTaskCargo($event,idSeccionTmp,tasklist._id);" ng-keydown="onActTaskCargo()">
                                    {{tasklist.cargoResponsable}}
                                </textarea>
                            </td>
                            <td style="width:10%; text-align: left;">
                                <mat-form-field>
                                    <input matInput [matDatepicker]="picker1" placeholder="Angular forms" [formControl]="date" (blur)="onDateTask($event,idSeccionTmp,tasklist._id);" ng-keydown="onActTaskCargo()">
                                    <mat-datepicker-toggle matSuffix [for]="picker1" (blur)="onDateTask($event,idSeccionTmp,tasklist._id);" ng-keydown="onDateTask()"></mat-datepicker-toggle>
                                    <mat-datepicker #picker1 (blur)="onDateTask($event,idSeccionTmp,tasklist._id);" ng-keydown="onDateTask()"></mat-datepicker>
                                </mat-form-field>
                            </td>
                            <td style="width:10%; text-align: left;">
                                <button mat-icon-button aria-label="" (click)="deleteFieldValueTaskFull(i,TaskListtmp,idSeccionTmp,tasklist._id)">
                                        <mat-icon>delete_forever</mat-icon>   
                                </button>

                            </td>
                        </tr>
                    </tbody>
                </table>
                <hr>



            </div>


        </div>





        <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->

</div>
<!-- / CENTER -->